import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getItemsAndPackagesSkus = fp.get(
  'inventory.reports.itemsAndPackagesSkus'
);

export const getAll = createSelector(getItemsAndPackagesSkus, fp.get('all'));

export const getIsFetching = createSelector(
  getItemsAndPackagesSkus,
  fp.get('fetching')
);
export const getIsFetched = createSelector(
  getItemsAndPackagesSkus,
  fp.get('fetched')
);
export const getFetchingError = createSelector(
  getItemsAndPackagesSkus,
  fp.get('fetchingError')
);
